import * as React from "react";
import CheckBox from "../../Checkbox";
import EditableHeading from '../../EditableHeading';
import { fileIconBasedOnFileName } from '../../../containers/WorkkardDetail/utils';
import Icons from '../../../icons';
import { downloadFile, fetchDownload } from '@/common/util';

export default class DefaultTemplate extends React.Component {
    EditableHeading;
    checkBoxChange;
    constructor(props) {
        super(props);
        this.state={
            checkboxValue:false,
            EditableMode:true
        }
        this.handleCheckboxChange=this.handleCheckboxChange.bind(this);
        this.handleDownloadClick=this.handleDownloadClick.bind(this);
        this.handlePreviewClick=this.handlePreviewClick.bind(this);
    }

    async handlePreviewClick(e){
        e.preventDefault();
        const defaultData = this.props.data;
        const previewTab = window.open('', '_blank');
        try{
            const response = await fetchDownload(defaultData.FileGuid);
            const blobUrl = window.URL.createObjectURL(response.data);
            previewTab.location = blobUrl;
        } catch(error){
            previewTab.close();
            console.log(error);
        }
    }

    async handleDownloadClick(e){
        e.preventDefault();
        const defaultData = this.props.data;
        try{
            await downloadFile(defaultData.FileGuid, defaultData.FileName);
        } catch(error){
            console.log(error);
        }
    }

    componentDidMount(){
        if(this.props.data.CanModifyCaption){
            this.setState({
                EditableMode:this.props.data.CanModifyCaption
            })
        }
        else{
            this.setState({
                EditableMode:this.props.EditableMode
            })
        }
    }

    UNSAFE_componentWillReceiveProps(newProps){
        if(newProps.isSelectAll !== this.props.isSelectAll){
            this.setState({
                checkboxValue:  newProps.extraData.selectedFiles && newProps.extraData.selectedFiles.length > 0 && newProps.extraData.selectedFiles.filter(file => file.FileGuid === newProps.data.FileGuid).length > 0
            })
            
        }
        
    }

    handleCheckboxChange(e,file){
        this.setState({
            checkboxValue:(this.state.checkboxValue ? false:true)
        })

        this.props.handleSelectAllShow(!e.checked,file);
    }
    GetFileSizeByte(size){
        let fs = parseFloat(size);
            if (fs >= 1048576)
            {
                fs = fs / 1048576;
                return Math.round(fs).toString() + " MB";
            }
            //when size is more than 1 KB
            else if (fs >= 1024)
            {
                fs = fs / 1024;
                return Math.round(fs).toString() + " KB";
            }
            //when size is less than  1 KB
            return Math.round(fs).toString() + " bytes";
    }

    render() {
        const defaultData=this.props.data;
        let TruncateFileName = this.props.truncateFileName(defaultData.FileName);
        const nameExt = defaultData.FileName.substring(defaultData.FileName.lastIndexOf('.') + 1).toLowerCase();

        let fileSize = defaultData?.FileSize
        if(!fileSize.includes("bytes") && !fileSize.includes("KB") && !fileSize.includes("MB"))
        {
            fileSize = this.GetFileSizeByte(fileSize);
        }
        const obj = {
            name:`${fileIconBasedOnFileName(nameExt)}`
        }
        return (
            <div className="defaultTemplate">
                    <div className="flexGrow fileListing">
                        {
                            defaultData.FileType.toLowerCase() == 'pdf' ?
                            (
                                (defaultData.FilePreviewUrl && defaultData.FilePreviewUrl.trim()==="" || this.props.isPrintPreview) ?
                                <div className="filesMain">
                                    <Icons {...obj}/>
                                </div>
                                :
                                <a href="javascript:void(0)" onClick={this.handlePreviewClick}>
                                    <div className="filesMain">
                                        <Icons {...obj}/>
                                    </div>                                    
                                </a>
                            )
                            :
                            <div className="filesMain">
                                <Icons {...obj}/>
                            </div>
                        }
                        
                        <div className="fileInfo">
                        {
                            (defaultData.IsMultiDownload) ?
                            <div className="checkboxArea">
                                <CheckBox item={{id:(defaultData.NoteId || '') + defaultData.FileGuid,
                                checked:this.state.checkboxValue}}
                                handleCheckbox={(event)=>this.handleCheckboxChange(event,defaultData)}
                                />
                            </div>
                            : null
                        }

                        <span className="fileName quickTooltip-bottom" data-quicktooltip={this.props.isPrintPreview ? null: defaultData.FileName}>
                            {
                                (defaultData.FileGuid && !this.props.isPrintPreview) ?  <a className="downloadLink" href="javascript:void(0)" onClick={this.handleDownloadClick}>{TruncateFileName} ({fileSize}) <Icons name="download" className="icon ml" /></a> : <span>{TruncateFileName} ({fileSize})</span>
                            }
                        </span>
                        {
                            (this.state.EditableMode && !this.props.isPrintPreview) ?
                            <span>
                                <div className="inlineEditor">
                                    <EditableHeading
                                        heading={(defaultData.Caption !== null && defaultData.Caption.trim() == "") ? "" : defaultData.Caption}
                                        onHeadingEdited={this.props.handleSaveCaption}
                                        maxLength={180}
                                        id={defaultData}
                                        //isOpen={this.state.isOpen}
                                        ListingComponent={true}
                                        //showEditButton={(defaultData.Caption !== null && defaultData.Caption.trim() == "") ? false : true}
                                        ref={editable => this.EditableHeading = editable}
                                    />
                                </div>
                                <div className="fileAction">
                                    {(defaultData.Caption == null || defaultData.Caption.trim() == "") ? null : <React.Fragment><a className="mr__1" onClick={()=>{ this.EditableHeading.onEditClick()}}>Edit</a>
                                    <a className="deleteCaption" onClick={()=>this.props.handleDeleteCaption(defaultData)}>Delete</a></React.Fragment>}
                                </div>
                            </span>
                            :
                            <div className="fileNameDisplay">{defaultData.Caption}</div>
                        }
                        </div>
                    </div>

            </div>
        )
    }
}
